import React from "react";

function Header(props) {
  return (
    <div>
      <h1>Splink settings editor with autocomplete and validation</h1>
      <p>
        Use the code editor below to author a <code>splink</code> settings
        dictionary.
      </p>
    </div>
  );
}

export default Header;
